import { getQuotesByUser, getToFundDataByUser } from "../redux/invoiceSlice";
import {
  getConnectedSoftware,
  disconnectConnectedSoftware,
  singleConnectedSoftware
} from "../redux/loginSlice";
import { useDispatch } from "react-redux";

const useAccountingSoftwareApi = () => {
  const dispatch = useDispatch();

  const GetConnectedSoftware = async () => {
    const response = await dispatch(getConnectedSoftware()).unwrap();
    return response;
  };

  const DisconnectSoftware = async (accountingSoftwareId) => {
    const response = await dispatch(
      disconnectConnectedSoftware(accountingSoftwareId)
    ).unwrap();
    return response;
  };

  const FundedDataCheck = async () => {
    const response = await dispatch(getQuotesByUser({})).unwrap();
    return response;
  };

  const ToFundDataCheck = async () => {
    const response = await dispatch(getToFundDataByUser({})).unwrap();
    return response;
  };

  const SingleConnectedSoftware = async () => {
    const response = await dispatch(singleConnectedSoftware()).unwrap();
    return response;
  };

  return {
    GetConnectedSoftware,
    DisconnectSoftware,
    FundedDataCheck,
    ToFundDataCheck,
    SingleConnectedSoftware
  };
};

export default useAccountingSoftwareApi;
